(function () {
    'use strict';

    let module = angular.module("imApp");

    module.factory("translateListService", ['$ihttp', function ($ihttp) {
        let service = {
            getTranslate: function (parms) {
                return $ihttp.post({
                    method: 1127,
                    parameters: parms || {}
                });
            },
            listLanguages: function (parms) {
                return $ihttp.post({
                    method: 57,
                    parameters: parms || {}
                });
            },
            listTranslations: function (parms) {
                return $ihttp.post({
                    method: 60,
                    parameters: parms || {}
                });
            },
            listSearchTranslations: function (parms) {
                return $ihttp.post({
                    method: 2966,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
